import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App.tsx';
import './css/globals.css';
import { persistor, store } from './redux/index.ts';
import Spinner from './views/spinner/Spinner.tsx';
const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(
  <Suspense fallback={<Spinner />}>
    
  
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
   
  </Suspense>,
);
